module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_c('button', {
    on: {
      "click": _vm.change_msg
    }
  }, [_vm._v("更改msg的值")])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Original message: \"" + _vm._s(_vm.message) + "\"")]), _vm._v(" "), _c('p', [_vm._v("Computed reversed message: \"" + _vm._s(_vm.reversedMessage) + "\"")])]), _vm._v(" "), _c('p', [_c('button', {
    on: {
      "click": _vm.change_message
    }
  }, [_vm._v("更改message的值")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.firstName) + _vm._s(_vm.lastName) + "=========" + _vm._s(_vm.fullName))]), _vm._v(" "), _c('p', [_c('button', {
    on: {
      "click": _vm.change_fullName
    }
  }, [_vm._v("更改fullName的值")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "watch-example"
    }
  }, [_c('p', [_vm._v("\n      Ask a yes/no question:\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.question),
      expression: "question"
    }],
    domProps: {
      "value": (_vm.question)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.question = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.answer))])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v(_vm._s(_vm.checked))])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }],
    attrs: {
      "type": "checkbox",
      "id": "jack",
      "value": "Jack"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "Jack") > -1 : (_vm.checkedNames)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Jack",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "jack"
    }
  }, [_vm._v("Jack")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }],
    attrs: {
      "type": "checkbox",
      "id": "john",
      "value": "John"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "John") > -1 : (_vm.checkedNames)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "John",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "john"
    }
  }, [_vm._v("John")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }],
    attrs: {
      "type": "checkbox",
      "id": "mike",
      "value": "Mike"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "Mike") > -1 : (_vm.checkedNames)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Mike",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "mike"
    }
  }, [_vm._v("Mike")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Checked names: " + _vm._s(_vm.checkedNames))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "example-4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.picked),
      expression: "picked"
    }],
    attrs: {
      "type": "radio",
      "id": "one",
      "value": "One"
    },
    domProps: {
      "checked": _vm._q(_vm.picked, "One")
    },
    on: {
      "__c": function($event) {
        _vm.picked = "One"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v("One")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.picked),
      expression: "picked"
    }],
    attrs: {
      "type": "radio",
      "id": "two",
      "value": "Two"
    },
    domProps: {
      "checked": _vm._q(_vm.picked, "Two")
    },
    on: {
      "__c": function($event) {
        _vm.picked = "Two"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "two"
    }
  }, [_vm._v("Two")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Picked: " + _vm._s(_vm.picked))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "example"
    }
  }, [_vm._v("全局\n      "), _c('my-component')], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "example"
    }
  }, [_vm._v("局部\n      "), _c('child')], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "example-2"
    }
  }, [_c('simple-counter'), _vm._v(" "), _c('simple-counter'), _vm._v(" "), _c('simple-counter')], 1), _vm._v(" "), _c('child-msg', {
    attrs: {
      "message": "hello!",
      "my-message": _vm.parentMsg
    }
  }), _vm._v(" "), _c('p', [_c('button', {
    on: {
      "click": _vm.change_Parmsg
    }
  }, [_vm._v("更改父组件parentMsg的值")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "counter-event-example"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.total))]), _vm._v(" "), _c('button-counter', {
    on: {
      "increment": _vm.incrementTotal
    }
  }), _vm._v(" "), _c('button-counter', {
    on: {
      "increment": _vm.incrementTotal
    }
  })], 1), _vm._v(" "), _c('toast', {
    attrs: {
      "msg": _vm.msg
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "demo"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v("\n      Toggle\n    ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show) ? _c('p', [_vm._v("hello")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.show) ? _c('p', [_vm._v("hello")]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [(_vm.show) ? _c('p', [_vm._v("Look at me!")]) : _vm._e()])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title-normal"
  }, [_c('h2', {
    staticClass: "page-title-h2"
  }, [_c('span', [_vm._v("test")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("不改变: " + _vm._s(_vm.msg))])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("filters: " + _vm._s(_vm._f("capitalize")(_vm.message)))])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f331c12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/test.vue
// module id = 76
// module chunks = 0